import { Injectable } from '@angular/core';
import { AppHttpClient } from '../api.interceptor';
import { environment } from '@env/environment';
import { HelpersService } from '@base/shared/services/helpers.service';

@Injectable()
export class ProjectsRequests {
  private config = environment;

  constructor(
    private http: AppHttpClient,
    private helpers: HelpersService
  ) {
  }

  /**
   * Create a new project
   */
  createProject(payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.projects}`;
    return this.http.post(url, payload);
  }

  /**
   * Get projects lists
   */
  list(type, payload) {
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/${type}${query}`;
    return this.http.get(url);
  }

  /**
   * Get list Daily Logs
   */
  listDailyLogs(payload){
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}/list/`;
    //const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogs}${query}`;
    //{{domain}}/v2/daily_logs?max_date_inclusive=2019-06-06&page=1&contract_daily_log_definition_Id=1
    //{{domain}}/v2/daily_logs?calendarDate=2019-06-06&page=1&contractId=1&state&statusTypeId=3&key=success"
    return this.http.get(url, payload);
  }


  /**
   * Get list Contracts
   */
  listContracts(contractId, payload){
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/${contractId}/daily_status/list${query}`;
    return this.http.get(url);
  }

  /**
   * Get list Contracts for a reviewer
   */
  listContractsReviewer(payload){
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/reviewer${query}`;
    return this.http.get(url);
  }

  /**
   * Get list Daily Contracts
   */
  listDailyContract(contractId, payload) {
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/${contractId}/daily_status/list${query}`;
    return this.http.get(url);
  }

  /**
   * Show Contract Daily Status
   */
  showContractDailyStatus(contractId, payload){
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.contracts}/${contractId}/daily_status/show${query}`;
    ///v2/contracts/1/daily_status/show?calendarDate=2019-06-18
    return this.http.get(url);
  }

  /**
   * Get Daily Log Definition
   */
  getDailyLogDefinitions(payload){
    const query = this.helpers.queryOptions(payload);
    const url = `${this.config.baseUrl}/v2/${this.config.services.dailyLogDefinitions}${query}`;
    //{{domain}}/v2/daily_log_definitions?project_id=1
    return this.http.get(url);
  }

  getSettings(projectId) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.projects}/${projectId}/settings`;
    return this.http.get(url);
  }

  updateProject(projectId, payload) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.projects}/${projectId}`;
    return this.http.patch(url, payload);
  }

  toggleStatus(projectId) {
    const url = `${this.config.baseUrl}/v2/${this.config.services.projects}/${projectId}/toggle`;
    return this.http.post(url, {});
  }


}
